module.exports = __webpack_public_path__ + "img/shouyebg.437a3f43.png";